<template>
  <div class="btn-block-container">
    <el-button
      type="success"
      class="btn-block"
      @click="openCreateDialog"><i class="fa fa-plus"></i> Add/Update PO</el-button>
    <el-dialog
      :title="createPoTitle"
      :visible.sync="dialogFormVisible"
      @close="onClose">
      <el-upload
        v-if="!selectAddDestination && !showAddDestination"
        class="upload-demo"
        drag
        ref="upload"
        :headers="getHeaders"
        :action="actionUrl"
        :file-list="fileList"
        :on-error="uploadError"
        :on-success="uploadSuccess"
        :auto-upload="true"
        accept=".xls,.xlsx,.html">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
        <div
          slot="tip"
          class="el-upload__tip">Accepted files .html or .xlsx/.xls </div>
      </el-upload>
      <div v-if="selectAddDestination">
        <el-row>
          <el-form
            :model="selectAddDestinationForm"
            :rules="selectAddDestinationFormRule"
            ref="selectAddDestinationForm"
            label-width="120px"
            label-position="top">
            <el-form-item prop="option">
              <el-radio-group v-model="selectAddDestinationForm.option">
                <el-radio label="true">Yes, add a destination now.</el-radio>
                <el-radio label="false">No, i will add a destination later.</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-row>
      </div>
      <div v-if="showAddDestination">
        <el-row
          v-if="!addDestFormVisible"
          ref="destinationForm">
          <p>Search for a saved <strong>destination</strong> below or create a new one:</p>
          <el-row>
            <el-select
              v-if="!showInputDestination"
              class="select-destination"
              v-model="destQuery"
              filterable
              placeholder="Select a saved destination..."
              @change="handleSelect"
              no-data-text="No saved destinations">
              <el-option
                v-for="item in getCustomersAddresses"
                :key="item[0].id"
                :label="item[0].name"
                :value="item[0].id">
              </el-option>
              <p></p>
            </el-select>
            <p
              class="show-input-name"
              @click="showInputDestination = true"
              v-if="!showInputDestination">Click here to add a new destination</p>
            <el-input
              placeholder="Add a name for the new destination"
              v-model="destinationName"
              v-if="showInputDestination"></el-input>
            <p
              class="show-input-name"
              @click="showInputDestination = false"
              v-if="showInputDestination">Go back to selection</p>
          </el-row>

        </el-row>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="showAddDestination">
        <el-button
          type="success"
          :loading="isLoading"
          @click="submitDestination">{{ createdPoOperation.status ?
        'Create PO' : 'Update PO' }}</el-button>
      </span>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="selectAddDestination">
        <el-button
          type="success"
          :loading="isLoading"
          @click="submitSelectAddDestination('selectAddDestinationForm')">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import apiUrl from '@/services/api_url';
import getFileUploadHeaders from '@/services/http-file-headers';

export default {
  data() {
    return {
      selectAddDestination: false,
      showAddDestination: false,
      dialogFormVisible: false,
      showInputDestination: false,
      isUploading: false,
      fileList: [],
      formLabelWidth: '120px',
      destQuery: '',
      createdPoId: null,
      createdPoOperation: null,
      addDestFormVisible: false,
      selectedDestination: null,
      selectedDestinationId: null,
      savedDestinations: [],
      isDestSelected: false,
      isLoading: false,
      destinationName: '',
      actionUrl: '',
      isNewPo: true,
      selectAddDestinationForm: {
        option: '',
      },
      selectAddDestinationFormRule: {
        option: [
          { required: true, message: 'Please select an option', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      getCustomers: 'getCustomers',
    }),
    getCustomersAddresses() {
      const destinations = this.getCustomers
        .filter(a => a.customerAddresses.length > 0)
        .map(a => a.customerAddresses);
      return destinations;
    },
    getHeaders() {
      return getFileUploadHeaders();
    },
    createPoTitle() {
      if (this.showAddDestination) {
        return 'Now add a destination for the PO';
      } else if (this.selectAddDestination) {
        return 'Add a destination for this PO?';
      }
      return 'Add a file to create a PO or update a existing one';
    },
  },
  created() {
    this.$store.dispatch('setCustomers');
    this.actionUrl = `${apiUrl}pos/`;
  },
  methods: {
    openCreateDialog() {
      this.dialogFormVisible = true;
      this.$store.dispatch('setCustomers');
    },
    onClose() {
      this.addDestFormVisible = false;
      this.showInputDestination = false;
      this.showAddDestination = false;
      this.selectAddDestination = false;
    },
    destQuerySearch(queryString, cb) {
      const customers = this.getCustomers;
      customers.forEach((obj) => {
        this.savedDestinations.push(obj.customerAddresses);
      });
      const results = queryString ? customers.filter(this.createFilter(queryString)) : customers;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return customer => (customer.value.indexOf(queryString) === 0);
    },
    submitUpload() {
      if (this.$refs.upload.$children[0].fileList[0]) {
        this.isUploading = true;
        this.$refs.upload.submit();
      } else {
        this.$message.warning('You need to select a file');
      }
    },
    uploadError() {
      this.isUploading = false;
      this.$message.error('Something went wrong. Try again.');
    },
    uploadSuccess(response) {
      if (response.operation.status) {
        this.createdPoId = response.id;
        this.createdPoOperation = response.operation;
        this.isUploading = false;
        this.$message({
          message: 'PO validated!',
          type: 'success',
        });
        this.isNewPo = response.operation.status;
        this.selectAddDestination = true;
      } else {
        this.createdPoId = response.id;
        this.isUploading = false;
        this.$message({
          message: 'PO updated!',
          type: 'success',
        });
        this.$store.dispatch('getSearchedPOData');
        this.fileList = [];
        this.$router.push({ name: 'po-detail', params: { id: this.createdPoId } });
      }
    },
    handleSelect(item) {
      this.selectedDestinationId = item;
      this.isDestSelected = true;
    },
    submitSelectAddDestination(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.selectAddDestinationForm.option === 'true') {
            this.selectAddDestination = false;
            this.showAddDestination = true;
          } else {
            this.$message({
              message: this.isNewPo ? 'PO created!' : 'PO updated!',
              type: 'success',
            });
            this.$store.dispatch('getSearchedPOData');
            this.$router.push({ name: 'po-detail', params: { id: this.createdPoId } });
          }
        }
        return false;
      });
    },
    submitDestination() {
      if (this.selectedDestinationId) {
        const destinationObj =
        { poId: this.createdPoId, destinationId: this.selectedDestinationId };
        this.isLoading = true;
        this.$store.dispatch('updateCustomerAddress', destinationObj);
        return this.$router.push({ name: 'po-detail', params: { id: this.createdPoId } });
      } else if (this.destinationName !== '') {
        const destinationObj = { poId: this.createdPoId, destinationName: this.destinationName };
        this.isLoading = true;
        this.$store.dispatch('updateCustomerAddress', destinationObj);
        return this.$router.push({ name: 'po-detail', params: { id: this.createdPoId } });
      }
      return this.$message({
        message: 'Select a destination or create a new one!',
        type: 'warning',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-upload,.el-autocomplete,.el-select {
  width: 100%;
}
.el-form-item__label {
  font-weight: 300;
}
button {
  margin: 0;
}
.btn-block-container{
  width: 100%;
  .btn-block{
    width: 100%;
  }
}

.el-select.select-destination {
  padding-left: 0;
}
.show-input-name {
  cursor: pointer;
  text-decoration: underline;
  margin: 15px 0;
  &:hover {
    text-decoration: none;
  }
}
.el-radio {
  font-weight: 300;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/partials/CreatePo.vue